"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCardInDeckRequest = instanceOfCardInDeckRequest;
exports.CardInDeckRequestFromJSON = CardInDeckRequestFromJSON;
exports.CardInDeckRequestFromJSONTyped = CardInDeckRequestFromJSONTyped;
exports.CardInDeckRequestToJSON = CardInDeckRequestToJSON;
exports.CardInDeckRequestToJSONTyped = CardInDeckRequestToJSONTyped;
/**
 * Check if a given object implements the CardInDeckRequest interface.
 */
function instanceOfCardInDeckRequest(value) {
    if (!('card' in value) || value['card'] === undefined)
        return false;
    return true;
}
function CardInDeckRequestFromJSON(json) {
    return CardInDeckRequestFromJSONTyped(json, false);
}
function CardInDeckRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'card': json['card'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}
function CardInDeckRequestToJSON(json) {
    return CardInDeckRequestToJSONTyped(json, false);
}
function CardInDeckRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'card': value['card'],
        'quantity': value['quantity'],
    };
}
//# sourceMappingURL=cardInDeckRequest.js.map